(function zoom(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.Modules.ImageZoom ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.Pipe
  ) {
    return;
  }

  const previousZoom = global.NewHomeSource.FullImageViewer.Zoom;
  const canvasElement = global.document.createElement('canvas');
  const zoomInQuery = '[data-full-image-viewer-role="zoom-in"]';
  const zoomOutQuery = '[data-full-image-viewer-role="zoom-out"]';
  const zoomInElement = global.document.querySelector(zoomInQuery);
  const zoomOutElement = global.document.querySelector(zoomOutQuery);
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const querySwiperContianer = '[data-full-image-viewer-role="swiper-container"]';
  const queryZoomControls = '[data-full-image-viewer-role="zoomControls"]';
  const isDisplayedInCarousel = global.document.querySelector(querySwiperContianer);
  const widthAttribute = 'width';
  const heightAttribute = 'height';
  const hidden = 'hidden';
  let imageZoom;
  let imagesContainer = global.document
    .querySelector(global.NewHomeSource.FullImageViewer.Config.queryImagesContainer);

  /**
   * @private
   * isSelected: function for getting the selected item of a given array of objects.
   * @param {object} element with the IsSelected boolean flag.
   */
  function isSelected(element) {
    return element.IsSelected;
  }

  /**
   * @private
   * setSizes: sets the width and height to the canvas element.
   * @param {object} data where we are going to grab the given width and height.
   */
  function setSizes(data) {
    canvasElement.setAttribute(widthAttribute, data.width);
    canvasElement.setAttribute(heightAttribute, data.height);
    canvasElement.classList.add('player__zoom-canvas');
  }

  /**
  * @private
  * getCarouselWidth: returns a container width for displaying a canvas element
  * in the best way given a device to show it
  * @param {object} size representing the result of a invocation on the getBoundingClientRect function.
  */
  function getCarouselWidth(size) {
    return (global.window.orientation === -90 || global.window.orientation === 90) ? size.width - 200 : size.width;
  }

  /**
  * @private
  * onOrientationChange: for carousel porpuses we listen to this event instead of loading a module as dekstops.
   * This will fired when an user roated her/his device 90 degrees, and is in charge of adjusting the canvas
   * element for the best UX given the device new position
  */
  function onOrientationChange() {
    canvasElement.remove();
    requestAnimationFrame(() => {
      const currentViewerState = global.NewHomeSource.FullImageViewerState.get();
      const currentImage = currentViewerState.images.find(isSelected);
      global.NewHomeSource.FullImageViewerState.setImage(currentImage);
    });
  }

  /**
  * @private
  * displayZoomControls: displays or hides the zooming controls for the canvas element.
   * @param {object} zoomControls DOM element.
   * @param {string} displayValue for the display style attribute.
   * @param {string} functionForClassList could be add or remove to the classList.
  */
  function displayZoomControls(zoomControls, displayValue, functionForClassList) {
    const zoomControl = zoomControls;
    if (zoomControl) {
      zoomControl.style.display = displayValue;
      zoomControl.classList[functionForClassList]('zoom-controls-floorplan');
    }
  }

  /**
  * @private
  * displayCanvas: attaches the canvas element to the DOM.
  */
  function displayCanvas() {
    imagesContainer = global.document
      .querySelector(global.NewHomeSource.FullImageViewer.Config.queryImagesContainer);
    const zoomControls = global.document.querySelector(queryZoomControls);
    canvasElement.style.display = 'none';

    if (zoomControls) {
      const size = imagesContainer.getBoundingClientRect();
      const height = size.height - 40;
      const width = getCarouselWidth(size);

      canvasElement.setAttribute('width', width);
      canvasElement.setAttribute('height', height);

      global.addEventListener('orientationchange', onOrientationChange);
    }

    imageZoom = new global.NewHomeSource.Modules.ImageZoom(canvasElement, this.Source);
    imagesContainer.prepend(canvasElement);
    imagesContainer.classList.remove('player-box');

    imageZoom.picture.onerror = function () {
      imageZoom.picture.src = global.NewHomeSource.FullImageViewer.Config.defaultThumbs.NoPhoto;

      if (isDisplayedInCarousel) {
        imagesContainer.removeAttribute('data-rich-slide');
        imagesContainer.querySelector('PICTURE').appendChild(imageZoom.picture);
      } else {
        canvasElement.style.display = 'block';
      }

      zoomInElement.setAttribute(hidden, '');
      zoomOutElement.setAttribute(hidden, '');
      imagesContainer.classList.remove('swiper-slide-floorplan');
      displayZoomControls(zoomControls, 'none', 'remove');
    };

    imageZoom.picture.addEventListener('load', () => {
      if (imageZoom.picture.src === global.NewHomeSource.FullImageViewer.Config.defaultThumbs.NoPhoto) {
        return;
      }

      canvasElement.style.display = 'block';
      imagesContainer.classList.add('swiper-slide-floorplan');
      zoomInElement.removeAttribute(hidden);
      zoomOutElement.removeAttribute(hidden);
      displayZoomControls(zoomControls, 'flex', 'add');
    });
  }

  /**
  * @private
  * resize: sets new values for the width and height of the canvas element.
  */
  function resize(data) {
    setSizes(data);

    if (imageZoom) {
      imageZoom.resize(canvasElement.getAttribute(widthAttribute), canvasElement.getAttribute(heightAttribute));
    }
  }

  /**
   * @private
   * handleResize: checks if the topic message indicates a resize action is needed.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  function handleResize(data, topic) {
    if (topic !== 'onResize') {
      return true;
    }

    requestAnimationFrame(resize.bind(null, data));
    return false;
  }

  /**
  * @private
  * hideCanvas: removes the canvas element from the DOM.
  */
  function hideCanvas() {
    if (!isDisplayedInCarousel) {
      imagesContainer.removeChild(canvasElement);
      imagesContainer.classList.add('player-box');
    } else {
      global.document.querySelector(queryZoomControls).style.display = 'none';
      imagesContainer.classList.remove('swiper-slide-floorplan');
    }
    zoomInElement.setAttribute(hidden, true);
    zoomOutElement.setAttribute(hidden, true);
  }

  /**
   * @private
   * render: creates and display the canvas object with the zoom and pan features.
   *
   * @param {object} data information of the object to be rendered.
   */
  function render(data) {
    imagesContainer = global.document
      .querySelector(global.NewHomeSource.FullImageViewer.Config.queryImagesContainer);

    if (!imagesContainer) {
      return data;
    }

    requestAnimationFrame(displayCanvas.bind(data));
    imagesContainer.prepend(canvasElement);
    return data;
  }

  /**
  * @private
  * zoomIn: increases the dimensions of the image.
  */
  function zoomIn() {
    imageZoom.zoom(true);
  }

  /**
  * @private
  * zoomIn: increases the dimensions of the image.
  */
  function zoomOut() {
    imageZoom.zoom(false);
  }

  /**
  * @private
  * shouldBeIgnored: hides the Canvas element if the current element is not zoomable.
  *
  * @param {object} data information that was changed.
  */
  function shouldBeIgnored(data) {
    const isCanvas = global.NewHomeSource.FullImageViewer.Config.isZoomableCollection(data);

    if (!isCanvas && canvasElement.parentElement) {
      hideCanvas(isCanvas);
    }
    return isCanvas;
  }

  /**
   * @constructs NewHomeSource.FullImageViewer.Zoom
   */
  function Zoom() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  Zoom.update = function update(data, topic) {
    global.NewHomeSource.Pipe.conditionalPipe(handleResize, shouldBeIgnored, render)(data, topic);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Zoom to the previous script.
   */
  Zoom.noConflict = function noConflict() {
    global.NewHomeSource.Zoom = previousZoom;
    return Zoom;
  };

  const events = {
    zoomIn: {
      callbacks: [zoomIn],
      elements: zoomInQuery,
      events: [eventToAttach],
    },
    zoomOut: {
      callbacks: [zoomOut],
      elements: zoomOutQuery,
      events: [eventToAttach],
    },
  };

  global.NewHomeSource.Event(events);
  global.NewHomeSource.FullImageViewerState.add('onImageSet', Zoom);
  global.NewHomeSource.FullImageViewerState.add('onResize', Zoom);
  global.NewHomeSource.FullImageViewer.Zoom = Zoom;
}(window));
